import { createStore } from "vuex";
import { request } from "../libs/request";

export default createStore({
  state: {
    projectData: {},
    totalArea: 0,
    categoryName:"",
    streetName:"",
    placeName:""
  },
  mutations: {
    setProjectInfo(state, payload) {
      state.projectData = payload;
      state.totalArea = payload.totalArea;
    },
  },
  getters: {
    getProjectStatistics(state) {
      let { totalArea } = state.projectData;
      return totalArea;
    },
    getFilterName(state){
      return [state.categoryName,state.streetName,state.placeName].filter(item=>item!='').join(",");
    }
  },
  actions: {
    getProject(store) {
      return new Promise((resolve) => {
        request.fetchPost("/screen/project").then((res) => {
          if (res.status == 200) {
            store.commit("setProjectInfo", res.data);
            resolve(res.data);
          }
        });
      });
    },
    // 中间收入达成监控大屏
    getIncomeData(store) {
      return new Promise((resolve) => {
        request.fetchPost("/screen/income").then((res) => {
          if (res.status == 200) {
            resolve(res.data);
          }
        });
      });
    },
    // 物业大屏
    getPropertyData(store) {
      return new Promise((resolve) => {
        request.fetchPost("/screen/property").then((res) => {
          if (res.status == 200) {
            resolve(res.data);
          }
        });
      });
    },
    // 安防大屏
    getSecurityData(store) {
      return new Promise((resolve) => {
        request.fetchPost("/screen/security").then((res) => {
          if (res.status == 200) {
            resolve(res.data);
          }
        });
      });
    },
  },
});
